import { render, staticRenderFns } from "./SvgLine.html?vue&type=template&id=45e2d870&scoped=true&"
import script from "./SvgLine.js?vue&type=script&lang=js&"
export * from "./SvgLine.js?vue&type=script&lang=js&"
import style0 from "./svg-line.scss?vue&type=style&index=0&id=45e2d870&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e2d870",
  null
  
)

export default component.exports